















import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { api as deskApi } from "../../store/modules/desk";
import {
  Decks,
  ReleativOrderEntry,
  PlaceName,
} from "../../store/modules/desk/types";
import { TrickCard } from "@dokogd/shared";
import DoKoCard from "../card/DoKoCard.vue";

@Component({ components: { DoKoCard } })
export default class DoKoCurrentTrick extends Vue {
  readonly positions: { [p: string]: string } = {
    bottom: "rotate(-4.32) translate(549 384)",
    left: "rotate(262) translate(-519 430)",
    top: "rotate(4.84) translate(607 176)",
    right: "rotate(-85.2) translate(-370 632)",
  };

  @Getter(deskApi.getters.getRelativeOrder, { namespace: deskApi.namespace })
  relativeOrder!: ReleativOrderEntry[];

  @Getter(deskApi.getters.getCurrentTrick, { namespace: deskApi.namespace })
  currentTrick!: TrickCard[];

  get cards() {
    return this.currentTrick.map((trickCard) => {
      const participantId = trickCard.participantId;
      const ro = this.relativeOrder.find(
        (r) => r.participantId === participantId
      );
      const place: PlaceName = ro ? ro.place : "bottom";
      return {
        name: trickCard.card,
        transform: this.positions[place],
      };
    });
  }
}
